import { useSelector } from "react-redux"
import React, { useEffect, useRef, useState } from 'react';
import { uploadFileData } from "../../services/upload-files.service";

const WaterData = ({ month, year, facility_id, setIsMounted, keys }) => {
    const loading = useSelector((state) => state.facilities.loading);
    const paperandcorrugatedboxesData = useSelector((state) => state.facilities.data.facilitiesdatapoint.water);
    const [data, setData] = useState(paperandcorrugatedboxesData);
    const [editableRowId, setEditableRowId] = useState(null);
    const [attachment, setAttachment] = useState()
    const [formDatas, setFormDatas] = useState()
    const [isloading, setIsLoading] = useState(false);
    const inputRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isActionButton =
                event.target.type === 'file' || event.target.classList.value == "fa-regular fa-pen-to-square";

            // Exclude Save and Cancel buttons from setting editableRowId to null
            if (!isActionButton && editableRowId !== null && !inputRef.current.contains(event.target)) {
                // Check if the clicked element is not the Save or Cancel button based on content
                const buttonText = event.target.classList.value.toLowerCase();
                if (buttonText != 'fa-solid fa-check' && buttonText != 'fa-solid fa-ban') {
                    setEditableRowId(null);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [editableRowId]);


    useEffect(() => {
        setData(paperandcorrugatedboxesData);
    }, [paperandcorrugatedboxesData]);

    const handleEditClick = (id) => {
        setEditableRowId(id);

    };

    const handleEditDblClick = (id) => {
        setEditableRowId(id);
    }

    const [isDisabled, setIsDisabled] = useState(true);

    const handleSaveClick = async (idx) => {
        setFormDatas({
            data_point_id: data[keys][idx].id,
            amount: data[keys][idx].amount,
            energy: data[keys][idx].energy ? data[keys][idx].energy : 0,
            emission: data[keys][idx].emission ? data[keys][idx].emission : 0,
            facility_id: facility_id,
            month: month,
            year: year,
            attachment: attachment /*? attachment : data[keys][idx].attachment*/
        }
        );
        setEditableRowId(null);
    };

    useEffect(() => {
        if (formDatas) {
            setIsLoading(true)
            try {
                uploadFileData(formDatas, "facilities/datapoint").then((res) => {
                    if (res.status === 200) {
                        setIsMounted(true)
                        setFormDatas(null)
                        setAttachment(null)
                        setIsLoading(false)
                    }
                });
            } catch (error) {
                console.error(error);
            }
        }
    }, [formDatas]);

    const handleCancelClick = () => {
        setEditableRowId(null);
    };

    const handleInputChange = (event, id) => {
        const { name, value } = event.target;
        // Update the data state with the new value
        setData((prevData) => {
            const updatedKeys = prevData[keys].map((item) => {
                if (item.id === id) {
                    const updatedItem = { ...item, [name]: value };
                    if (name === "amount" && !isNaN(parseFloat(value))) {
                        let values = value.replace(/[^\d.]/g, '');
                        const stringValue = values.toString();
                        const parts = stringValue.split('.');
                        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        updatedItem.amount = parts.join('.')
                    }
                    return updatedItem;
                }
                return item
            }
            );
            return {
                ...prevData,
                [keys]: updatedKeys,
            };
        });
    };

    const handleFileChange = (event, id) => {
        const file = event.target.files[0];
        setAttachment(file)
    };


    if (isloading) {
        return (
            <>
                <main className="col-md-12">
                    <h1 className="h2 py-2"> <i class="fa-solid fa-spinner fa-spin"></i></h1>
                </main>
            </>
        )
    }

    return (
        <>
            {data[keys] && data[keys].length > 0 ? (
                data[keys].map((curData, idx) => {
                    const { id, name, amount, unit, attachment } = curData;
                    return (
                        <tr key={id}>
                            <td>{name ? name : "--"}</td>
                            <td className="clickable" onDoubleClick={() => handleEditDblClick(id)} disabled={editableRowId !== null}>
                                {editableRowId === id ? (
                                    <input
                                        type="text"
                                        name="amount"
                                        ref={inputRef}
                                        value={amount}
                                        onChange={(e) => handleInputChange(e, id)}
                                    />
                                ) : (
                                    <span title="Double click to edit">{amount}</span>
                                )}
                            </td>
                            <td>{unit}</td>
                            <td>
                                {editableRowId === id ? (
                                    <input
                                        type="file"
                                        accept=".xlsx"
                                        onChange={(e) => handleFileChange(e, id)}
                                    />
                                ) : (
                                    <span>
                                        <i className="fa-solid fa-paperclip"></i>
                                        {attachment ? (
                                            <a href={attachment} target="_blank" rel="noopener noreferrer">
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                )}
                            </td>
                            <td>
                                {editableRowId === id ? (
                                    <>
                                        <button className="custom-button" onClick={() => handleSaveClick(idx)}><i className="fa-solid fa-check"></i></button>
                                        <button className="custom-button" onClick={handleCancelClick}><i className="fa-solid fa-ban"></i></button>
                                    </>
                                ) : (
                                    <button className="custom-button" onClick={() => handleEditClick(id)} disabled={editableRowId !== null}><span><i className="fa-regular fa-pen-to-square"></i></span></button>
                                )}
                            </td>
                        </tr>
                    );
                })
            ) : (
                <tr>
                    <td colSpan="6">No data available.</td>
                </tr>
            )}
        </>
    );
};

export default WaterData;
